/**
 * 追従フッターブロックのフロントエンドスクリプト
 * フッターエリアに到達したら非表示になる機能
 */
import './style.scss';

// スクロールイベントの処理をディバウンスする関数
function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

document.addEventListener('DOMContentLoaded', () => {
    // 追従フッターブロックの要素を取得
    const stickyFooter = document.querySelector('.wp-block-spocale-blocks-sticky-footer');
    
    // フッターエリアの要素を取得（テーマに合わせて調整）
    // よりWordPressのGenesis/Astra/Twenty Twentyテーマなどで一般的なセレクタを追加
    const footer = document.querySelector('.footer, #footer, .l-footer');
    
    // 両方の要素が存在する場合のみ処理を続行
    if (stickyFooter && footer) {
        // 初期状態では表示する
        stickyFooter.classList.remove('is-hidden');
        // Intersection Observerの設定
        const options = {
            root: null, // ビューポートをルートとする
            rootMargin: '100px', // 余裕を持たせる（フッターが画面に入る100px手前から検知）
            threshold: 0.05 // 5%表示されたら検知（より早めに検知）
        };
        
        // フッターの表示を監視するObserverを作成
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // フッターが見えたら追従フッターを非表示に
                    stickyFooter.classList.add('is-hidden');
                } else {
                    // フッターが見えていないなら追従フッターを表示
                    stickyFooter.classList.remove('is-hidden');
                }
            });
        }, options);
        
        // フッターの監視を開始
        observer.observe(footer);
        
        // フッター位置の確認とフッターの表示/非表示を切り替える関数
        const checkFooterVisibility = () => {
            // 現在のフッターの位置を確認
            const footerRect = footer.getBoundingClientRect();
            
            // フッターがビューポートに入ったかどうかを判断
            // 余裕を持たせて、フッターがウィンドウ高さの90%以下に来たときに非表示にする
            const visibilityThreshold = window.innerHeight * 0.9;
            const isFooterVisible = footerRect.top < visibilityThreshold;
            
            if (isFooterVisible) {
                // フッターが見えたら追従フッターを非表示に
                stickyFooter.classList.add('is-hidden');
            } else {
                // フッターが見えなくなったら追従フッターを表示
                stickyFooter.classList.remove('is-hidden');
            }
        };
        
        // 初期表示時にもフッター位置をチェック
        checkFooterVisibility();
        
        // ディバウンスしたスクロールハンドラを登録（200ミリ秒の遅延）
        window.addEventListener('scroll', debounce(checkFooterVisibility, 200), { passive: true });
    }
});
